import { Link } from 'react-router-dom'

/**
 * Customer landing page. v0.2 dropped the magic-link signup gate — there's
 * nothing to sign up to; the customer just clicks through to the code-entry
 * page where the resolver auto-creates their record on first join.
 */
export function CustomerHome() {
  return (
    <div className="max-w-md mx-auto bg-white rounded-2xl shadow-sm border border-slate-200 p-8 text-center">
      <h1 className="text-2xl font-semibold mb-2">Secure chat with your support team</h1>
      <p className="text-sm text-slate-600 mb-8">
        Stay on the call with your agent and click below to enter the
        one-time code they share with you.
      </p>

      <Link
        to="/join"
        className="inline-block w-full rounded-lg bg-blue-600 text-white text-sm font-medium px-4 py-3 hover:bg-blue-700"
      >
        I have a code → Enter Code
      </Link>

      <p className="mt-8 text-xs text-slate-500">
        SecureBridge is a U.S.-based, opt-in companion channel. By joining a
        chat you agree not to share sensitive info unless requested by your
        company. Sessions may be logged for compliance.
      </p>
    </div>
  )
}
